import React, { useCallback, useEffect, useState } from 'react'
import context from '@/context'
import LoadingIndicator from '@/components/LoadingIndicator'
import { useLocalization } from '@/hooks/localization'

function ReportInfo ({ reportCode }) {
  const [reportInfo, setReportInfo] = useState()
  const [displayInfo, setDisplayInfo] = useState(false)

  const { localizeValue } = useLocalization()

  const onMouseEnter = useCallback(() => {
    setDisplayInfo(true)
  }, [])

  const onMouseLeave = useCallback(() => {
    setDisplayInfo(false)
  }, [])

  useEffect(() => {
    if (displayInfo && !reportInfo) {
      context.api.outputReportService.getReportInfo(reportCode)
        .then(response => setReportInfo(response || { categoryName: '', latinCategoryName: '', name: '', latinName: '' }))
        .catch(() => { })
    }
  }, [reportCode, reportInfo, displayInfo])

  return <React.Fragment>
    <span onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      {reportCode}
      {displayInfo && !reportInfo && <LoadingIndicator inline />}
      {displayInfo && reportInfo && <small><i><span> {localizeValue(reportInfo.categoryName, reportInfo.latinCategoryName)} - {localizeValue(reportInfo.name, reportInfo.latinName)}</span></i></small>}
    </span>
  </React.Fragment>
}

export { ReportInfo }



// WEBPACK FOOTER //
// ./src/internal-app/pages/outputReportGroupDefinitions/reportInfo.js